import {colorPrimitive} from '../../styles/primitives/colorPrimitive';

export interface BorderSemanticStyles {
  primary: string;
  secondary: string;
  tertiary: string;
  alpha: string;
  focus: string;
  brand: string;
  danger: string;
  warning: string;
  disabled: string;
  'disabled-secondary': string;
  inverse: string;
  focusInverse: string;
}

export const lightBorderSemanticStyles: BorderSemanticStyles = {
  primary: colorPrimitive.gray[500],
  secondary: colorPrimitive.gray[300],
  tertiary: colorPrimitive.gray[200],
  alpha: colorPrimitive.alpha.black.black200,
  focus: colorPrimitive.blue[600],
  brand: colorPrimitive.purple[600],
  danger: colorPrimitive.red[600],
  warning: colorPrimitive.yellow[500],
  disabled: colorPrimitive.alpha.transparent,
  'disabled-secondary': colorPrimitive.alpha.black.black100,
  inverse: colorPrimitive.gray.white,
  focusInverse: colorPrimitive.alpha.black.black500,
};

export const redesignedLightBorderSemanticStyles: BorderSemanticStyles = {
  ...lightBorderSemanticStyles,
  focus: colorPrimitive.blurple[600],
  warning: colorPrimitive.yellow[500],
};

export const darkBorderSemanticStyles: BorderSemanticStyles = {
  primary: colorPrimitive.gray[700],
  secondary: colorPrimitive.gray[800],
  tertiary: colorPrimitive.gray[900],
  alpha: colorPrimitive.alpha.white.white200,
  focus: colorPrimitive.blue[600],
  brand: colorPrimitive.purple[600],
  danger: colorPrimitive.red[600],
  warning: colorPrimitive.yellow[400],
  disabled: colorPrimitive.alpha.transparent,
  'disabled-secondary': colorPrimitive.alpha.white.white100,
  inverse: colorPrimitive.gray.black,
  focusInverse: colorPrimitive.alpha.white.white500,
};

export const redesignedDarkBorderSemanticStyles: BorderSemanticStyles = {
  ...darkBorderSemanticStyles,
  focus: colorPrimitive.blurple[600],
  primary: colorPrimitive.gray[700],
  secondary: colorPrimitive.gray[800],
  warning: colorPrimitive.yellow[400],
};
